import { useCallback, useRef } from 'react';

// Stolen from https://medium.com/swlh/using-a-debounced-callback-in-react-ade57d31ca6b
/* eslint-disable @typescript-eslint/no-explicit-any */
const useDebouncedCallback = <T extends Array<any>>(func: (...args: T) => void, wait: number) => {
  const timeout = useRef<NodeJS.Timeout>();

  return useCallback(
    (...args: T) => {
      const later = () => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- this is only called after setTimeout is called
        clearTimeout(timeout.current!);
        func(...args);
      };

      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      timeout.current = setTimeout(later, wait);
    },
    [func, wait],
  );
};

export { useDebouncedCallback };
